import { useEffect, useRef } from 'react';
import { setSidebarVisibility } from 'react-admin';
import { useSelector, useDispatch } from 'react-redux';
import { usePreferences } from '../';
/**
 * Save Sidebar open status in Preferences, and restore it on load.
 *
 * @example
 *
 *     import { SidebarOpenPreferenceSync } from '@react-admin/ra-preferences';
 *
 *     const MyLayout = props => (
 *         <>
 *             <SidebarOpenPreferenceSync />
 *             <Layout {...props} />
 *         </>
 *     );
 *
 *     export const App = () => (
 *         <Admin dataProvider={dataProvider} layout={MyLayout}>
 *             ...
 *         </Admin>
 *     );
 */
export var SidebarOpenPreferenceSync = function () {
    var sidebarOpenFromStore = useSelector(function (state) { return state.admin.ui.sidebarOpen; });
    var _a = usePreferences('ui.sidebarOpen'), sidebarPref = _a[0], setSidebarPref = _a[1];
    var dispatch = useDispatch();
    var stateRef = useRef();
    useEffect(function () {
        if (typeof stateRef.current === 'undefined') {
            // first mount
            stateRef.current =
                typeof sidebarPref !== 'undefined'
                    ? sidebarPref
                    : sidebarOpenFromStore;
            if (typeof sidebarPref !== 'undefined' &&
                sidebarPref !== sidebarOpenFromStore) {
                // restore preference
                dispatch(setSidebarVisibility(sidebarPref));
            }
        }
        else {
            if (stateRef.current !== sidebarOpenFromStore) {
                // sidebar state changed in store
                if (sidebarPref !== sidebarOpenFromStore) {
                    // store latest state in preferences
                    setSidebarPref(sidebarOpenFromStore);
                    stateRef.current = sidebarOpenFromStore;
                }
            }
            else {
                // sidebar preference changed in localStorage (probably from another window)
                if (sidebarPref != undefined &&
                    sidebarPref !== sidebarOpenFromStore) {
                    // store latest preference in state
                    dispatch(setSidebarVisibility(sidebarPref));
                    stateRef.current = sidebarPref;
                }
            }
        }
    }, [dispatch, sidebarPref, setSidebarPref, sidebarOpenFromStore]);
    return null;
};
